import React from 'react';

export default function Button({ children, variant = 'primary', size = 'md', icon, onClick, disabled, style, type = 'button', fullWidth }) {
  const base = {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: 7,
    borderRadius: 10,
    fontWeight: 600,
    cursor: disabled ? 'not-allowed' : 'pointer',
    transition: 'all 0.2s cubic-bezier(0.4, 0, 0.2, 1)',
    border: '1px solid transparent',
    opacity: disabled ? 0.5 : 1,
    fontFamily: 'inherit',
    letterSpacing: '-0.01em',
    position: 'relative',
    overflow: 'hidden',
    width: fullWidth ? '100%' : undefined,
  };

  const sizes = {
    sm: { padding: '6px 14px', fontSize: 12 },
    md: { padding: '9px 18px', fontSize: 13 },
    lg: { padding: '12px 24px', fontSize: 14 },
  };

  const variants = {
    primary: {
      background: 'linear-gradient(135deg, #00CEEE 0%, #00E3E2 50%, #009995 100%)',
      color: '#fff',
      borderColor: 'transparent',
      boxShadow: '0 2px 8px rgba(0, 206, 238, 0.3)',
    },
    secondary: {
      background: '#F1F5F9',
      color: '#475569',
      borderColor: '#E2E8F0',
    },
    danger: {
      background: '#EF4444',
      color: '#fff',
      borderColor: '#EF4444',
      boxShadow: '0 2px 8px rgba(239, 68, 68, 0.3)',
    },
    ghost: {
      background: 'transparent',
      color: '#009995',
      borderColor: '#00CEEE',
    },
    outline: {
      background: 'transparent',
      color: '#64748B',
      borderColor: '#E2E8F0',
    },
    success: {
      background: '#10B981',
      color: '#fff',
      borderColor: '#10B981',
      boxShadow: '0 2px 8px rgba(16, 185, 129, 0.3)',
    },
  };

  return (
    <button type={type} onClick={onClick} disabled={disabled}
      style={{ ...base, ...sizes[size], ...variants[variant], ...style }}>
      {icon && <span style={{ display: 'flex', alignItems: 'center', flexShrink: 0 }}>{icon}</span>}
      {children}
    </button>
  );
}
